export interface Permission {
  action: PermissionAction;
  explicit?: boolean;
  // eslint-disable-next-line camelcase
  resource_type: PermissionResourceType;
  resource: string[];
}

export enum PermissionAction {
  ALL = 'ALL',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  EXECUTE = 'EXECUTE',
  GRANT = 'GRANT',
  READ = 'READ',
  REVOKE = 'REVOKE',
  WRITE = 'WRITE',
}

export enum PermissionResourceType {
  '*' = '*',
  ADMIN = 'admin',
  DATASOURCE = 'data-source',
  DB = 'db',
  ICVCONSTRAINTS = 'icv-constraints',
  METADATA = 'metadata',
  NAMEDGRAPH = 'named-graph',
  ROLE = 'role',
  USER = 'user',
  VIRTUALGRAPH = 'virtual-graph',
}
